import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const centerTextPlugin = {
  id: "centerTextPlugin",

  beforeDraw(chart, args, pluginOptions) {
    const { ctx, width, height } = chart;

    ctx.save();

    const clientCount = pluginOptions.clientCount || 0;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#212529";
    ctx.fillText(clientCount, width / 2, height / 2 - 6);

    ctx.font = "14px Arial";
    ctx.fillStyle = "#6c757d";
    ctx.fillText("Clients", width / 2, height / 2 + 14);

    ctx.restore();
  },
};

function RevenueOutstandingClient ({ chart_data }) {
  if (!Array.isArray(chart_data) || chart_data.length === 0) {
    return <div>No data available</div>;
  }


//   const labels = chart_data.map(item => item.client_name);
//   const values = chart_data.map(item => Number(item.total_amount));
//   const colors = labels.map((_, index) => `hsl(${index * 50}, 70%, 55%)`);
  
    const TOP_N = 5;
    const sortedData = [...chart_data].sort((a, b) => Number(b.total_amount) - Number(a.total_amount));
    const topClients = sortedData.slice(0, TOP_N);
    const others = sortedData.slice(TOP_N);
    const othersTotal = others.reduce((sum, item) => sum + Number(item.total_amount), 0);
    const chartClients =
    othersTotal > 0
        ? [...topClients, { client_name: "Others", total_amount: othersTotal }]
        : topClients;
  const labels = chartClients.map(item => item.client_name);
  const values = chartClients.map(item => Number(Number(item.total_amount).toFixed(2)));
  const colors = labels.map((_, index) => `hsl(${index * 150}, 70%, 55%)`);

  const data = {
    labels,
    datasets: [
      {
        label: "Outstanding",
        data: values,
        backgroundColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "55%",
    plugins: {
      legend: { display: false, position: "bottom" },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `₹ ${ctx.parsed.toFixed(2)} Cr`,
        },
      },
    },
  };

  return (
    <div className="d-flex flex-column h-100">
      {/* <h6 className="text-center mb-2">Revenue Split</h6> */}
      <div className="d-flex justify-content-center align-items-center" style={{ height: 170 }}>
        <div style={{ width: 170 }}>
            <Doughnut
              data={data}
              plugins={[centerTextPlugin]}
              options={{
                ...options,
                plugins: {
                  ...options.plugins,
                  centerTextPlugin: {
                    clientCount: chart_data.length,
                  },
                },
              }}
            />
        </div>
      </div>

      <div className="mt-2 flex-grow-1 overflow-auto" style={{ minHeight: 0 }}>
        <table className="table table-sm mb-0">
          <tbody>
            {chart_data.map((item, index) => (
              <tr key={index}>
                <td width="20">
                  <span
                    style={{
                      width: 12,
                      height: 12,
                      display: "inline-block",
                      borderRadius: "50%",
                      ...(index < 5 && { backgroundColor: colors[index] }),
                    }}
                  />
                </td>
                <td className="text-truncate">{item.client_name}</td>
                <td className="text-end fw-semibold">
                  ₹ {Number(item.total_amount).toFixed(2)} Cr
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RevenueOutstandingClient;